module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/minimalist-77596d69ed1f4aa8f00049c0a62796cf.jpg";